/* Atelier: product discovery and accessible announcement rotation. Same-origin reads only. */
(() => {
 'use strict';
 const C=window.AtelierDiscovery;if(!C||!window.customElements)return;
 const key='atelier.recent.handles.v1';
 const root=window.Shopify?.routes?.root||document.querySelector('html').dataset.root||'/';
 const route=(s)=>root.replace(/\/?$/,'/')+s;
 const announceChange=()=>{
  if(window.AtelierWishlistUI)window.AtelierWishlistUI.sync();
  document.dispatchEvent(new CustomEvent('atelier:content:loaded'));
 };
 function loadNear(component,load){
  if(!('IntersectionObserver' in window)||window.Shopify?.designMode){load();return;}
  const anchor=component.previousElementSibling;
  if(!anchor?.hasAttribute('data-discovery-anchor')){load();return;}
  component.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)&&component.isConnected){component.observer.disconnect();load();}},{rootMargin:'400px 0px'});
  component.observer.observe(anchor);
 }
 async function html(url,signal){
  const u=new URL(url,location.origin);if(u.origin!==location.origin)throw new Error('origin');
  const control=new AbortController(),abort=()=>control.abort();
  signal?.addEventListener('abort',abort,{once:true});if(signal?.aborted)abort();
  const timer=setTimeout(abort,10000);
  try{const r=await fetch(u,{credentials:'same-origin',signal:control.signal,headers:{Accept:'text/html'}});if(!r.ok)throw new Error('http');return new DOMParser().parseFromString(await r.text(),'text/html');}
  finally{clearTimeout(timer);signal?.removeEventListener('abort',abort);}
 }
 function cards(source,limit,vendor){
  const family=v=>/emarola/i.test(v)?'women':/celopman/i.test(v)?'men':String(v||'').toLowerCase();
  const fragment=document.createDocumentFragment();
  for(const card of source.querySelectorAll('.product-card')){
   if(fragment.childElementCount>=limit)break;
   if(vendor&&family(card.dataset.vendor)!==family(vendor))continue;
   card.querySelectorAll('script,iframe,object,embed').forEach(n=>n.remove());
   card.querySelectorAll('*').forEach(n=>{for(const at of [...n.attributes])if(/^on/i.test(at.name))n.removeAttribute(at.name);});
   const link=card.querySelector('a[href]');if(!link||!C.productPath(link.getAttribute('href'),location.origin))continue;
   fragment.append(document.importNode(card,true));
  }
  return fragment;
 }
 class Recommendations extends HTMLElement{
  connectedCallback(){
   if(this.life)return;this.life=new AbortController();this.observer=null;
   const load=()=>{this.observer?.disconnect();this.load();};
   loadNear(this,load);
  }
  async load(){
   if(!this.dataset.url||this.loading)return;this.loading=true;
   const signal=this.life.signal;
   try{const doc=await html(this.dataset.url,signal);if(!this.isConnected||signal.aborted)return;const source=doc.querySelector('[data-recommendations-result]');if(!source)return;const result=cards(source,Number(this.dataset.limit)||4,this.dataset.currentVendor);if(!result.childElementCount)return;this.querySelector('[data-discovery-grid]').replaceChildren(result);this.hidden=false;announceChange();}
   catch{ /* Keep the server-rendered collection fallback, never display a broken panel. */ }
  }
  disconnectedCallback(){this.observer?.disconnect();this.life?.abort();this.life=null;this.loading=false;}
 }
 class Recent extends HTMLElement{
  connectedCallback(){
   if(this.life)return;this.life=new AbortController();this.loaded=false;
   let handles=[];try{handles=C.parseHandles(sessionStorage.getItem(key));}catch{}
   const current=this.dataset.current;
   const previous=handles.filter(h=>h!==current).slice(0,Math.min(4,Number(this.dataset.limit)||4));
   if(current){try{sessionStorage.setItem(key,JSON.stringify(C.remember(handles,current)));}catch{}}
   if(!previous.length)return;
   const load=()=>{this.observer?.disconnect();this.load(previous);};
   loadNear(this,load);
  }
  async load(handles){
   if(this.loaded)return;this.loaded=true;
   const signal=this.life.signal;
   const results=await Promise.allSettled(handles.map(h=>html(route('products/'+h)+'?section_id=atelier-discovery-card',signal)));
   if(!this.isConnected||signal.aborted)return;
   const fragment=document.createDocumentFragment();
   for(const result of results){if(result.status!=='fulfilled')continue;const source=result.value.querySelector('[data-discovery-card]');if(source)fragment.append(cards(source,1));}
   if(!fragment.childElementCount)return;
   this.querySelector('[data-discovery-grid]').replaceChildren(fragment);this.hidden=false;announceChange();
  }
  disconnectedCallback(){this.observer?.disconnect();this.life?.abort();this.life=null;}
 }
 class Announcements extends HTMLElement{
  connectedCallback(){
   if(this.life)return;this.life=new AbortController();const signal=this.life.signal;
   this.slides=[...this.querySelectorAll('[data-announcement-slide]')];if(!this.slides.length)return;
   this.index=0;this.manualPause=false;this.hovered=false;this.focused=false;this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
   this.slides.forEach((s,i)=>s.hidden=i!==0);
   const controls=this.querySelector('[data-announcement-controls]');if(controls)controls.hidden=this.slides.length<2;
   this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;if(b.hasAttribute('data-announcement-pause')){this.manualPause=!this.manualPause;this.paintPause();}else if(b.dataset.announcementStep){this.show(this.index+Number(b.dataset.announcementStep));}this.schedule();},{signal});
   this.addEventListener('pointerenter',()=>{this.hovered=true;this.schedule();},{signal});
   this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule();},{signal});
   this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},{signal});
   this.addEventListener('focusout',e=>{this.focused=this.contains(e.relatedTarget);this.schedule();},{signal});
   document.addEventListener('visibilitychange',()=>this.schedule(),{signal});
   this.reduced.addEventListener('change',()=>{this.paintPause();this.schedule();},{signal});
   document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===String(e.detail?.blockId));if(i>=0){this.manualPause=true;this.show(i);this.paintPause();this.schedule();}},{signal});
   this.paintPause();this.schedule();
  }
  show(i){this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((s,n)=>s.hidden=n!==this.index);}
  paintPause(){const b=this.querySelector('[data-announcement-pause]');if(!b)return;b.hidden=this.dataset.autoplay!=='true'||this.reduced.matches;b.setAttribute('aria-pressed',String(this.manualPause));b.textContent=this.manualPause?b.dataset.play:b.dataset.pause;}
  schedule(){clearTimeout(this.timer);if(this.dataset.autoplay!=='true'||this.manualPause||this.hovered||this.focused||this.reduced.matches||document.hidden||this.slides.length<2)return;this.timer=setTimeout(()=>{this.show(this.index+1);this.schedule();},Math.max(5,Number(this.dataset.interval)||7)*1000);}
  disconnectedCallback(){clearTimeout(this.timer);this.life?.abort();this.life=null;}
 }
 for(const [name,cl] of [['atelier-recommendations',Recommendations],['atelier-recent',Recent],['atelier-announcements',Announcements]])if(!customElements.get(name))customElements.define(name,cl);
})();
